/**
 * Success page shown after form submission
 */
/* eslint-disable */

import { useForm } from '@ox/visits-ui/context/FormContext';
import { SecondaryButton } from '@ox/visits-ui/components/shared/FormComponents';
import { formatDate } from '@ox/blox';

export function SuccessPage() {
  const { draft, setViewMode } = useForm();

  return (
    <div className="success-page" role="status" aria-live="polite">
      <div className="success-card" aria-label="Form submitted successfully">
        <span className="success-icon" aria-hidden="true" role="img">
          ✅
        </span>
        <h2 className="success-title">Visit Submitted Successfully</h2>
        <div className="success-content">
          <p>Property: {draft.propertyAddress}</p>
          <p>Submitted: {formatDate(draft.submittedAt, 'MM/DD/YYYY, HH:MI TZ')}</p>
          <p>What happens next:</p>
          <ul>
            <li><p>Processing within 2 minutes</p></li>
            {draft.visitType === 'Pre-Walk'
              ? (<li><p>Pricing. analyst will review within 24 hours</p></li>)
              : <li><p>Operations will review findings</p></li>
            }
            <li><p>You'll receive confirmation email</p></li>
          </ul>
        </div>
        <div className="button-group">
          <SecondaryButton onClick={() => setViewMode()}>View Submission</SecondaryButton>
          <SecondaryButton onClick={() => window.close()}>Done</SecondaryButton>
        </div>
      </div>
    </div>
  );
}